<app-message-box level="error" prominent="To protect your security, we've signed you out of your account"
                 [messages]="{message: message}"></app-message-box>